export default __webpack_public_path__ + "static/media/create-user-off.ffa6fd98.svg";